import React from 'react'
import './Tag.css'

export interface TagProps {
  label: string
  className?: string
}

export const Tag: React.FC<TagProps> = ({ label, className = '' }) => {
  return (
    <div className={`tag ${className}`}>
      <span className="tag-label">{label}</span>
    </div>
  )
}
